{
  "title": "Discover",
  "activityTitle": "Activity",
  "savedTitle": "Saved",
  "commands": {
    "open": "Discover",
    "search": "Search posts and people",
    "newPost": "New Post",
    "saved": "Saved",
    "drafts": "Drafts",
    "myPosts": "My Posts",
    "activity": "Activity"
  },
  "screens": {
    "abuse_or_harassment": "Abuse or harassment",
    "activity": "Activity",
    "additional_details_optional": "Additional details (optional)",
    "block_author": "Block author",
    "block_this_author": "Block this author?",
    "browse_discover": "Browse Discover",
    "cancel": "Cancel",
    "choose_a_comment_to_reply_to": "Choose a comment to reply to.",
    "comments": "Comments",
    "comments_are_closed": "Comments are closed.",
    "couldn_t_complete_the_action": "Couldn't complete the action",
    "couldn_t_complete_the_action_try_again": "Couldn't complete the action. Try again.",
    "couldn_t_delete_the_post_try_again": "Couldn't delete the post. Try again.",
    "couldn_t_load_comments_try_again": "Couldn't load comments. Try again",
    "couldn_t_load_the_post": "Couldn't load the post.",
    "couldn_t_send_the_comment_your_text_is_kept_try_again": "Couldn't send the comment. Your text is kept; try again.",
    "couldn_t_send_the_report_try_again": "Couldn't send the report. Try again.",
    "couldn_t_update_saved_try_again": "Couldn't update Saved. Try again.",
    "couldn_t_update_the_like_try_again": "Couldn't update the like. Try again.",
    "create_a_post": "Create a post",
    "delete": "Delete",
    "delete_this_post": "Delete this post?",
    "discover": "Discover",
    "done": "Done",
    "feed": "Feed",
    "following": "Following",
    "impersonation": "Impersonation",
    "inappropriate_content": "Inappropriate content",
    "intellectual_property": "Intellectual property",
    "latest": "Latest",
    "load_earlier_replies": "Load earlier replies",
    "load_more_comments": "Load more comments",
    "loading_comments": "Loading comments",
    "loading_post": "Loading post",
    "misinformation": "Misinformation",
    "newest_first": "Newest first",
    "ok": "OK",
    "other": "Other",
    "post": "Post",
    "post_in_this_topic": "Post in this topic",
    "privacy": "Privacy",
    "reason": "Reason",
    "replies": "Replies",
    "report": "Report",
    "report_received": "Report received",
    "search_posts_and_people": "Search posts and people",
    "send_report": "Send Report",
    "sort_posts": "Sort posts",
    "spam": "Spam",
    "start_the_conversation": "Start the conversation.",
    "thank_you_a_moderator_will_review_your_report": "Thank you. A moderator will review your report.",
    "the_post_will_no_longer_be_available_to_anyone": "The post will no longer be available to anyone.",
    "this_comment_is_no_longer_available": "This comment is no longer available.",
    "this_comment_is_no_longer_available_cancel_the_reply_to_comment_on_the_post": "This comment is no longer available. Cancel the reply to comment on the post.",
    "this_comment_is_no_longer_available_choose_another_comment_to_reply_to": "This comment is no longer available. Choose another comment to reply to.",
    "this_post_isn_t_available": "This post isn't available.",
    "this_topic_isn_t_available": "This topic isn't available.",
    "top": "Top",
    "topic": "Topic",
    "try_again": "Try Again",
    "up_to_1_000_characters": "Up to 1,000 characters",
    "update_hylo_to_view_this_content": "Update Hylo to view this content.",
    "use_send_to_submit_your_edited_comment": "Use Send to submit your edited comment.",
    "you_won_t_see_each_other_s_posts_and_you_ll_unfollow_each_other": "You won't see each other's posts, and you'll unfollow each other.",
    "reply": "Reply",
    "send": "Send",
    "show_comment": "Show comment",
    "hide_comment": "Hide comment",
    "show_thread": "Show thread",
    "hide_thread": "Hide thread",
    "pinned": "Pinned",
    "publish": "Publish",
    "publishing": "Publishing…",
    "edit": "Edit",
    "preview": "Preview",
    "save_close": "Save & Close",
    "title_optional": "Title (optional)",
    "body_format": "Body format",
    "plain_text": "Plain text",
    "community": "Community",
    "only_me": "Only me",
    "topics": "Topics",
    "on_this_device": "On this device",
    "taken_down": "Taken down",
    "draft": "Draft",
    "my_posts": "My Posts",
    "edited": "Edited",
    "rename": "Rename",
    "folder_name": "Folder name",
    "share_post": "Share post",
    "search": "Search",
    "notes": "Notes",
    "no_comments_yet": "No comments yet",
    "load_more": "Load more",
    "replying_to_name": "Replying to {{arg1}}",
    "add_a_comment": "Add a comment…",
    "couldn_t_copy_text": "Couldn’t copy text",
    "delete_comment": "Delete comment?",
    "unavailable_comment": "Unavailable comment",
    "comment_deleted": "Comment deleted",
    "this_comment_is_unavailable": "This comment is unavailable.",
    "view_replies": "View replies",
    "edit_post": "Edit post",
    "new_post": "New post",
    "share_something": "Share something…",
    "who_can_see_this_post": "Who can see this post?",
    "post_as": "Post as",
    "me": "Me",
    "manage_permissions": "Manage permissions",
    "add_photos_or_video": "Add photos or video",
    "mention_someone": "Mention someone",
    "uploaded": "Uploaded",
    "failed": "Failed",
    "move_up": "Move up",
    "move_down": "Move down",
    "no_activity_yet": "No activity yet",
    "hylo": "Hylo",
    "no_drafts_yet": "No drafts yet",
    "untitled_post": "Untitled post",
    "manage_post": "Manage post",
    "couldn_t_discard_draft": "Couldn’t discard draft",
    "published": "Published",
    "publish_failed": "Publish failed",
    "your_post_was_not_published_your_draft_is_safe": "Your post was not published. Your draft is safe.",
    "view_post": "View post",
    "cancel_publishing": "Cancel publishing",
    "retry_publishing": "Retry publishing",
    "change_visibility": "Change visibility?",
    "open": "Open",
    "closed": "Closed",
    "delete_post": "Delete post",
    "this_cannot_be_undone": "This cannot be undone.",
    "manage_folders": "Manage folders",
    "couldn_t_copy_link": "Couldn’t copy link",
    "profile": "Profile",
    "new_folder": "New folder",
    "all": "All",
    "delete_folder": "Delete folder?",
    "saved_posts_will_stay_in_all_saved": "Saved posts will stay in All Saved.",
    "no_saved_posts_yet": "No saved posts yet",
    "unsave": "Unsave",
    "rename_folder": "Rename folder",
    "add_to_folder": "Add to folder",
    "create": "Create",
    "report_sent": "Report sent",
    "submit": "Submit",
    "your_report_will_be_reviewed_reporting_does_not_hide_the_post": "Your report will be reviewed. Reporting does not hide the post.",
    "clear": "Clear",
    "sent": "Sent",
    "add_a_message_optional": "Add a message (optional)",
    "posts": "Posts",
    "followers": "Followers",
    "likes_saves": "Likes & Saves",
    "liked_your_post": "liked your post",
    "commented_on_your_post": "commented on your post",
    "replied_to_your_comment": "replied to your comment",
    "liked_your_comment": "liked your comment",
    "followed_you": "followed you",
    "people_saved_your_post": "people saved your post",
    "your_post_was_taken_down": "Your post was taken down",
    "your_comment_was_removed": "Your comment was removed",
    "your_post_was_restored": "Your post was restored",
    "your_report_will_be_reviewed_by_our_moderation_team": "Your report will be reviewed by our moderation team.",
    "retry": "Retry",
    "local_changes": "Local changes",
    "retry_pending_actions": "Retry pending actions",
    "hidden_posts": "Hidden posts",
    "muted_authors": "Muted authors",
    "show_post": "Show post",
    "show_posts_from_this_author": "Show posts from this author",
    "unavailable": "Unavailable",
    "save_failed": "Save failed",
    "needs_attention": "Needs attention",
    "preparing_video": "Preparing video…",
    "video_help": "Video help",
    "use_at_most_200_characters": "Use at most 200 characters.",
    "oldest_first": "Oldest first",
    "task": "Task",
    "read_more": "Read more",
    "show_less": "Show less",
    "comment": "Comment",
    "create_topic": "Create topic",
    "position": "Position",
    "post_format": "Post format",
    "formatting": "Formatting",
    "heading": "Heading",
    "bold": "Bold",
    "italic": "Italic",
    "list": "List",
    "quote": "Quote",
    "code": "Code",
    "link": "Link",
    "make_cover": "Make cover",
    "replace_cover": "Replace cover",
    "collapse": "Collapse",
    "show_replies": "Show replies",
    "mentioned_you": "mentioned you"
  },
  "secondary": {
    "name_commented_on_your_post": "{{arg1}} commented on your post",
    "name_followed_you": "{{arg1}} followed you",
    "name_mentioned_you": "{{arg1}} mentioned you",
    "name_replied_to_your_comment": "{{arg1}} replied to your comment",
    "count_count": "{{arg1}} / {{arg2}}",
    "count_new_likes_one": "{{count}} new like",
    "count_new_likes_other": "{{count}} new likes",
    "a_folder_with_this_name_already_exists_choose_another_name": "A folder with this name already exists. Choose another name.",
    "a_mentioned_name_is_missing_from_the_post_remove_the_mention_or_insert_it_again": "A mentioned name is missing from the post. Remove the mention or insert it again.",
    "a_moderation_decision_was_updated": "A moderation decision was updated",
    "a_newer_submission_replaced_this_one_check_drafts_for_its_status": "A newer submission replaced this one. Check Drafts for its status.",
    "activity": "Activity",
    "add_one_video_before_publishing": "Add one video before publishing.",
    "add_topic": "Add topic",
    "adjust_cover_focus": "Adjust Cover Focus",
    "all_formats": "All Formats",
    "all_saved_posts": "All Saved Posts",
    "all_topics": "All Topics",
    "allow_publishing_community_posts_as_me": "Allow publishing community posts as me",
    "an_attachment_can_t_be_used_in_this_post_remove_it_or_choose_another_file": "An attachment can't be used in this post. Remove it or choose another file.",
    "an_attachment_couldn_t_be_processed_your_draft_is_kept_replace_the_attachment_and_try_again": "An attachment couldn't be processed. Your draft is kept. Replace the attachment and try again.",
    "another_revision_was_published_your_draft_is_kept_refresh_before_trying_again": "Another revision was published. Your draft is kept. Refresh before trying again.",
    "author": "Author",
    "author_visibility": "Author & Visibility",
    "body_format": "Body format",
    "bold": "Bold",
    "cancel": "Cancel",
    "cancel_publishing": "Cancel Publishing",
    "checking_post": "Checking post…",
    "choose_a_video_shorter_than_10_minutes_up_to_9_59_5": "Choose a video shorter than 10 minutes (up to 9:59.5).",
    "choose_images": "Choose images",
    "choose_images_or_a_video": "Choose images or a video.",
    "choose_up_to_count_attachments": "Choose up to {{arg1}} attachments.",
    "choose_up_to_count_images": "Choose up to {{arg1}} images.",
    "choose_up_to_count_videos": "Choose up to {{arg1}} videos.",
    "choose_video": "Choose video",
    "clear_search_history": "Clear Search History",
    "close": "Close",
    "code": "Code",
    "community": "Community",
    "community_is_currently_unavailable_please_try_again_later": "Community is currently unavailable. Please try again later.",
    "couldn_t_complete_this_action_please_try_again": "Couldn't complete this action. Please try again.",
    "couldn_t_open_this_draft": "Couldn't open this draft.",
    "couldn_t_open_this_figure": "Couldn't open this figure.",
    "couldn_t_prepare_this_video_please_choose_another_file": "Couldn't prepare this video. Please choose another file.",
    "couldn_t_update_publishing_permission_the_switch_shows_the_latest_confirmed_setting_try_again": "Couldn't update publishing permission. The switch shows the latest confirmed setting. Try again.",
    "cover": "Cover",
    "create_topic_name": "Create topic “{{arg1}}”",
    "delete_folder": "Delete Folder",
    "delete_this_folder_saved_posts_will_be_kept": "Delete this folder? Saved posts will be kept.",
    "done": "Done",
    "draft": "Draft",
    "draft_on_this_device": "Draft on this device",
    "drafts": "Drafts",
    "edit": "Edit",
    "edit_folders": "Edit Folders",
    "edit_post": "Edit Post",
    "failed_draft_kept": "Failed · draft kept",
    "files": "Files",
    "find_people": "Find people",
    "find_topics": "Find topics",
    "focus_changes_the_card_crop_the_full_image_stays_visible_in_the_post": "Focus changes the card crop. The full image stays visible in the post.",
    "folder_name": "Folder name",
    "folders": "Folders",
    "follow": "Follow",
    "following": "Following",
    "format": "Format",
    "heading": "Heading",
    "horizontal_focus": "Horizontal focus",
    "image": "Image",
    "image_actions": "Image actions",
    "images_text": "Images & Text",
    "insert_image_or_video": "Insert image or video",
    "italic": "Italic",
    "latest": "Latest",
    "link": "Link",
    "list": "List",
    "live_figure": "Live figure",
    "load_more": "Load More",
    "loading_figure": "Loading figure",
    "loading_post": "Loading post…",
    "make_cover": "Make Cover",
    "markdown_publishing_is_unavailable_your_draft_stays_on_this_device": "Markdown publishing is unavailable. Your draft stays on this device.",
    "media": "Media",
    "media_is_inserted_at_the_cursor_and_kept_with_your_draft_while_it_uploads": "Media is inserted at the cursor and kept with your draft while it uploads.",
    "mention": "Mention",
    "move_earlier": "Move Earlier",
    "move_later": "Move Later",
    "my_posts": "My Posts",
    "new_folder": "New Folder",
    "new_post": "New Post",
    "new_activity": "New activity",
    "no_activity_yet": "No activity yet.",
    "no_drafts_on_this_device": "No drafts on this device.",
    "no_posts_yet": "No posts yet.",
    "no_results": "No results.",
    "no_saved_posts": "No saved posts.",
    "no_server_drafts": "No server drafts.",
    "not_selected": "Not selected",
    "on_this_device": "On This Device",
    "on_this_device_2": "On this device",
    "only_me": "Only me",
    "open_draft": "Open Draft",
    "opens_an_interactive_figure": "Opens an interactive figure",
    "people": "People",
    "plain_text": "Plain text",
    "please_sign_in_again_to_continue": "Please sign in again to continue.",
    "post_image": "Post image",
    "post_text": "Post text",
    "posting_as_name": "Posting as {{arg1}}",
    "posting_for_name": "Posting for {{arg1}}",
    "posts": "Posts",
    "preparing_media": "Preparing media…",
    "preview": "Preview",
    "publish": "Publish",
    "publishing_cancelled": "Publishing cancelled",
    "publishing_failed_open_to_edit_or_retry": "Publishing failed · open to edit or retry",
    "publishing_permission_ended_your_draft_is_kept_ask_the_author_to_renew_permission": "Publishing permission ended. Your draft is kept. Ask the author to renew permission.",
    "publishing_was_cancelled_your_draft_is_kept": "Publishing was cancelled. Your draft is kept.",
    "publishing_you_can_follow_progress_in_drafts": "Publishing. You can follow progress in Drafts.",
    "publishing": "Publishing…",
    "quote": "Quote",
    "ready": "Ready",
    "recent_searches": "Recent Searches",
    "refresh_status": "Refresh Status",
    "refresh_the_post_before_sharing_it": "Refresh the post before sharing it.",
    "relevance": "Relevance",
    "remove": "Remove",
    "remove_from_saved": "Remove from Saved",
    "remove_from_this_device": "Remove from This Device",
    "remove_mention_name": "Remove mention {{arg1}}",
    "remove_topic_name": "Remove topic {{arg1}}",
    "rename": "Rename",
    "rename_folder": "Rename Folder",
    "save": "Save",
    "save_close": "Save & Close",
    "save_failed_kept_on_this_device": "Save failed · kept on this device",
    "save_to_folders": "Save to Folders",
    "saved": "Saved",
    "saving": "Saving…",
    "search": "Search",
    "search_for": "Search for",
    "search_is_too_long_maximum_count_characters": "Search is too long (maximum {{arg1}} characters).",
    "search_posts_and_people": "Search posts and people",
    "selected": "Selected",
    "server_drafts": "Server Drafts",
    "someone": "Someone",
    "sort": "Sort",
    "submitted": "Submitted.",
    "submitted_check_drafts_for_the_publishing_status": "Submitted. Check Drafts for the publishing status.",
    "synced": "Synced",
    "synced_available_on_your_other_devices": "Synced · available on your other devices",
    "taken_down": "Taken down",
    "the_markdown_body_is_too_large_maximum_512_kib": "The Markdown body is too large (maximum 512 KiB).",
    "the_first_image_is_the_cover_reorder_images_or_adjust_the_cover_focus": "The first image is the cover. Reorder images or adjust the cover focus.",
    "the_post_is_too_long_maximum_count_characters": "The post is too long (maximum {{arg1}} characters).",
    "the_post_s_visibility_changed_refresh_before_publishing_again": "The post's visibility changed. Refresh before publishing again.",
    "the_prepared_video_exceeds_the_current_file_size_limit_choose_a_smaller_video": "The prepared video exceeds the current file size limit. Choose a smaller video.",
    "the_title_is_too_long_maximum_count_characters": "The title is too long (maximum {{arg1}} characters).",
    "this_account_is_suspended_and_can_t_complete_this_action": "This account is suspended and can't complete this action.",
    "this_action_isn_t_available_because_one_of_the_accounts_has_blocked_the_other": "This action isn't available because one of the accounts has blocked the other.",
    "this_assistant_or_permission_is_no_longer_available_refresh_the_assistant_settings": "This assistant or permission is no longer available. Refresh the assistant settings.",
    "this_attachment_isn_t_available": "This attachment isn't available.",
    "this_community_is_read_only_changes_can_t_be_saved_right_now": "This community is read-only. Changes can't be saved right now.",
    "this_content_or_account_is_no_longer_available": "This content or account is no longer available.",
    "this_draft_changed_on_another_device_both_copies_have_been_kept_in_drafts": "This draft changed on another device. Both copies have been kept in Drafts.",
    "this_file_couldn_t_be_opened": "This file couldn't be opened.",
    "this_file_is_too_large_for_a_community_post": "This file is too large for a community post.",
    "this_permission_changed_on_another_device_refresh_and_try_again": "This permission changed on another device. Refresh and try again.",
    "this_permission_changed_on_another_device_the_switch_has_been_refreshed_try_again": "This permission changed on another device. The switch has been refreshed. Try again.",
    "this_post_already_has_a_newer_draft_open_it_from_drafts": "This post already has a newer draft. Open it from Drafts.",
    "this_post_doesn_t_meet_the_current_publishing_requirements_check_the_text_topics_and_attachments": "This post doesn't meet the current publishing requirements. Check the text, topics and attachments.",
    "this_post_format_isn_t_supported": "This post format isn't supported.",
    "this_post_isn_t_available": "This post isn't available.",
    "this_post_was_taken_down_and_can_t_be_published_now": "This post was taken down and can't be published now.",
    "this_video_couldn_t_be_accepted_choose_it_again_or_use_another_file": "This video couldn't be accepted. Choose it again or use another file.",
    "this_video_exceeds_the_current_duration_limit_choose_a_shorter_video": "This video exceeds the current duration limit. Choose a shorter video.",
    "this_video_needs_h_264_video_and_aac_audio_choose_it_again_to_prepare_a_compatible_mp4": "This video needs H.264 video and AAC audio. Choose it again to prepare a compatible MP4.",
    "this_video_s_resolution_is_too_high_prepare_it_at_1080p_or_lower": "This video's resolution is too high. Prepare it at 1080p or lower.",
    "title_optional": "Title (optional)",
    "too_many_mentions": "Too many mentions.",
    "too_many_requests_wait_a_moment_and_try_again": "Too many requests. Wait a moment and try again.",
    "too_many_topics": "Too many topics.",
    "topic": "Topic",
    "topics": "Topics",
    "try_again": "Try Again",
    "unavailable_account": "Unavailable account",
    "unknown_visibility": "Unknown visibility",
    "unpublished_changes": "Unpublished changes",
    "untitled_draft": "Untitled Draft",
    "upload_failed_retry_from_drafts": "Upload failed · retry from Drafts",
    "uploading": "Uploading…",
    "use_images_or_one_video_in_a_post": "Use images or one video in a post.",
    "vertical_focus": "Vertical focus",
    "video": "Video",
    "videos_are_prepared_as_h_264_mp4_with_a_cover_location_metadata_is_removed": "Videos are prepared as H.264 MP4 with a cover. Location metadata is removed.",
    "visibility": "Visibility",
    "waiting_for_status": "Waiting for status",
    "waiting_to_upload": "Waiting to upload",
    "what_would_you_like_to_share": "What would you like to share?",
    "write_something_or_add_an_image": "Write something or add an image.",
    "you_can_keep_drafting_publishing_as_this_author_needs_permission": "You can keep drafting. Publishing as this author needs permission.",
    "you_can_t_change_this_assistant_s_publishing_permission_check_that_you_are_signed_in_as_its_owner": "You can't change this assistant's publishing permission. Check that you are signed in as its owner.",
    "you_don_t_have_permission_to_complete_this_action": "You don't have permission to complete this action.",
    "you_ve_reached_the_saved_folder_limit_delete_a_folder_before_creating_another": "You've reached the saved folder limit. Delete a folder before creating another.",
    "your_assistant_may_publish_edit_change_visibility_and_comment_as_you_you_can_turn_this_off_at_any_time": "Your assistant may publish, edit, change visibility and comment as you. You can turn this off at any time.",
    "your_post_was_saved_count_times_one": "Your post was saved {{count}} time",
    "your_post_was_saved_count_times_other": "Your post was saved {{count}} times",
    "conflicting_copy": "Conflicting copy",
    "save_failed": "Save failed",
    "on_server": "On server"
  },
  "ui": {
    "name_of_name": "{{arg1}} of {{arg2}}",
    "count_comments_one": "{{count}} comment",
    "count_comments_other": "{{count}} comments",
    "count_likes_one": "{{count}} like",
    "count_likes_other": "{{count}} likes",
    "count_saves_one": "{{count}} save",
    "count_saves_other": "{{count}} saves",
    "answering_name": "Answering @{{arg1}}: ",
    "author": "Author",
    "block_author": "Block author",
    "cancel_reply": "Cancel reply",
    "cancel_the_reply_to_comment_on_the_post": "Cancel the reply to comment on the post.",
    "check_your_connection_and_try_again": "Check your connection and try again.",
    "choose_a_comment_to_reply_to": "Choose a comment to reply to.",
    "close": "Close",
    "close_comments": "Close comments",
    "collapse_replies": "Collapse replies",
    "comment": "Comment",
    "comments": "Comments",
    "comments_are_closed": "Comments are closed",
    "copy": "Copy",
    "copy_link": "Copy Link",
    "couldn_t_load_more_try_again": "Couldn't load more. Try again",
    "couldn_t_load_posts": "Couldn't load posts",
    "couldn_t_load_replies_try_again": "Couldn't load replies. Try again",
    "couldn_t_open_this_figure": "Couldn't open this figure.",
    "delete": "Delete",
    "deleted_account": "Deleted account",
    "discover_isn_t_available": "Discover isn't available",
    "edit": "Edit",
    "edited": "Edited",
    "exit_full_screen": "Exit Full Screen",
    "find_people": "Find People",
    "follow": "Follow",
    "follow_people_to_see_their_new_posts_here": "Follow people to see their new posts here.",
    "following": "Following",
    "full_screen": "Full Screen",
    "hidden_by_the_post_s_author": "Hidden by the post's author.",
    "hidden_from_other_readers": "Hidden from other readers",
    "hide_comment": "Hide comment",
    "hide_posts_from_this_author": "Hide posts from this author",
    "hide_this_post": "Hide this post",
    "hide_thread": "Hide thread",
    "image": "Image",
    "in_reply_to_name": "In reply to {{arg1}}",
    "in_reply_to_a_deleted_comment": "In reply to a deleted comment",
    "like": "Like",
    "live_figure": "Live figure",
    "loading_figure": "Loading figure",
    "loading_more_posts": "Loading more posts",
    "loading_post": "Loading post",
    "loading_posts": "Loading posts",
    "loading_replies": "Loading replies…",
    "loading_video": "Loading video",
    "make_visible_only_to_me": "Make visible only to me",
    "more": "More",
    "mute": "Mute",
    "next_photo": "Next photo",
    "no_posts_from_people_you_follow_yet": "No posts from people you follow yet",
    "no_posts_yet": "No posts yet",
    "not_sent_retry": "Not sent. Retry",
    "only_you_can_see_this": "Only you can see this",
    "open_comments": "Open comments",
    "open_profile": "Open profile",
    "opens_the_photo_full_screen": "Opens the photo full screen",
    "opens_the_post": "Opens the post",
    "opens_the_profile": "Opens the profile",
    "pause": "Pause",
    "photo": "Photo",
    "photo_count_of_count": "Photo {{arg1}} of {{arg2}}",
    "pin": "Pin",
    "pinned": "Pinned",
    "play": "Play",
    "playback_position": "Playback position",
    "posts_shared_with_the_community_appear_here": "Posts shared with the community appear here.",
    "previous_photo": "Previous photo",
    "removed_for_breaking_the_community_rules": "Removed for breaking the community rules.",
    "reply": "Reply",
    "reply_to_name": "Reply to {{arg1}}",
    "reply_to_a_deleted_comment": "Reply to a deleted comment: ",
    "replying_to_name": "Replying to @{{arg1}}",
    "report": "Report",
    "save": "Save",
    "say_something": "Say something…",
    "send": "Send",
    "sending": "Sending…",
    "share": "Share",
    "share_with_the_community": "Share with the community",
    "show_count_more_replies_one": "Show {{count}} more reply",
    "show_count_more_replies_other": "Show {{count}} more replies",
    "show_comment": "Show comment",
    "show_more": "Show more",
    "show_more_replies": "Show more replies",
    "show_thread": "Show thread",
    "taken_down": "Taken down",
    "the_community_is_turned_off_for_your_account": "The community is turned off for your account.",
    "this_comment_is_no_longer_available": "This comment is no longer available.",
    "this_comment_isn_t_available": "This comment isn't available.",
    "this_comment_was_deleted": "This comment was deleted.",
    "this_post_isn_t_available": "This post isn't available.",
    "this_video_can_t_be_played": "This video can't be played.",
    "thread_hidden_from_other_readers": "Thread hidden from other readers",
    "topic_name": "Topic {{arg1}}",
    "topics": "Topics",
    "try_again": "Try Again",
    "unmute": "Unmute",
    "unpin": "Unpin",
    "update_hylo_to_view_this_post": "Update Hylo to view this post.",
    "video": "Video",
    "video_name": "Video, {{arg1}}",
    "write_a_reply_to_name": "Write a reply to @{{arg1}}…",
    "you_can_t_comment_on_this_post": "You can't comment on this post",
    "you_re_all_caught_up": "You're all caught up",
    "by_name": "by {{arg1}}",
    "remove": "Remove",
    "copied": "Copied",
    "show_posts_from_this_author": "Show posts from this author",
    "saved": "Saved",
    "done": "Done",
    "show_post": "Show post",
    "post": "Post"
  },
  "confirmation": {
    "a_person_whose_private_data_was_used_must_confirm_publication": "A person whose private data was used must confirm publication.",
    "an_attachment_isn_t_available_you_can_decline_or_ask_the_agent_for_a_new_request": "An attachment isn’t available. You can decline or ask the agent for a new request.",
    "attachment_is_processing": "Attachment is processing",
    "attachment_unavailable": "Attachment unavailable",
    "awaiting_confirmation": "Awaiting confirmation",
    "cancel": "Cancel",
    "community": "Community",
    "confirm": "Confirm",
    "confirm_publication": "Confirm publication",
    "couldn_t_complete_this_action_try_again": "Couldn’t complete this action. Try again.",
    "couldn_t_load_the_preview": "Couldn’t load the preview.",
    "decline": "Decline",
    "declined": "Declined",
    "done": "Done",
    "draft_changed": "Draft changed",
    "mentions": "Mentions",
    "only_the_author": "Only the author",
    "only_you": "Only you",
    "open_published_post": "Open published post",
    "post_awaiting_confirmation": "Post awaiting confirmation",
    "post_preview": "Post preview",
    "preparing_publication": "Preparing publication…",
    "preview_post": "Preview post",
    "publication_confirmed": "Publication confirmed",
    "publication_failed": "Publication failed",
    "publication_is_blocked_you_can_still_decline_this_request": "Publication is blocked. You can still decline this request.",
    "publish_as_name": "Publish as {{arg1}}",
    "publish_in_the_named_person_s_name": "Publish in the named person’s name",
    "publish_in_your_name": "Publish in your name",
    "the_request_changed_review_it_again": "The request changed. Review it again.",
    "this_draft_changed_ask_the_agent_for_a_new_publish_request": "This draft changed. Ask the agent for a new publish request.",
    "this_post_can_t_be_published_ask_the_agent_to_correct_it": "This post can’t be published. Ask the agent to correct it.",
    "this_request_isn_t_available": "This request isn’t available.",
    "topics": "Topics",
    "try_again": "Try Again",
    "unsupported_attachment": "Unsupported attachment",
    "update_hylo_to_view_all_attachments_before_confirming": "Update Hylo to view all attachments before confirming.",
    "update_hylo_to_view_this_request": "Update Hylo to view this request",
    "wait_until_all_attachments_are_ready_to_view_before_confirming": "Wait until all attachments are ready to view before confirming.",
    "withdrawn": "Withdrawn",
    "publishing": "Publishing…",
    "review_this_request_in_the_original_chat": "Review this request in the original chat.",
    "published": "Published",
    "review_before_publishing": "Review before publishing",
    "requested_by_name": "Requested by {{arg1}}",
    "this_request_is_no_longer_available": "This request is no longer available.",
    "post_publication_request": "Post publication request",
    "open_original_request": "Open original request",
    "review_post": "Review post"
  },
  "shared": {
    "share_post": "Share post",
    "choose_chats": "Choose chats",
    "search_chats": "Search chats",
    "add_a_comment_optional": "Add a comment (optional)",
    "choose_up_to_10_chats": "Choose up to 10 chats.",
    "choose_up_to_count_chats": "Choose up to {{arg1}} chats.",
    "published": "Published.",
    "copied": "Copied",
    "retry": "Retry",
    "cancel": "Cancel",
    "send": "Send",
    "notes": "Notes",
    "selected": "Selected",
    "not_selected": "Not selected"
  },
  "web": {
    "offline": "You’re offline. Your draft is kept on this device.",
    "connectToOpen": "Connect to the internet to open this post.",
    "unavailableForAccount": "Discover isn’t available for this account.",
    "refresh": "Refresh",
    "saveAsNew": "Save as a new post",
    "openServerDraft": "Open server draft",
    "retryFailed": "Retry failed chats",
    "shareComplete": "Shared",
    "shareFailed": "Couldn’t share to this chat. Try again.",
    "invalidLink": "This link isn’t valid.",
    "unsupportedVideo": "Choose an H.264 MP4 with AAC audio or no audio.",
    "videoHelp": "A cover is created and location metadata is removed from compatible MP4 files.",
    "largeVideoUploadUnavailable": "This browser build cannot upload this video size yet. Your file is kept in Drafts.",
    "bodyTooComplex": "This Markdown is too complex to publish. Simplify its tables or formatting and try again.",
    "altText": "Image description (optional)",
    "appeal": "Appeal",
    "appealText": "Explain your appeal",
    "submitAppeal": "Submit Appeal",
    "appealSent": "Appeal submitted",
    "underReview": "Under review",
    "upheld": "Decision upheld",
    "restored": "Restored",
    "moderationCase": "Moderation decision",
    "unmuteAuthor": "Show posts from this author",
    "unblockAuthor": "Unblock author",
    "removeFromFolder": "Remove from this folder",
    "discardDraft": "Discard server draft",
    "discardDraftConfirm": "Discard this server draft? Your published post will be kept.",
    "removeLocalConfirm": "Remove this draft from this device?",
    "retryUpload": "Retry upload",
    "openOriginalChat": "Open original chat",
    "loading": "Loading…",
    "focusHorizontal": "Cover focus · horizontal",
    "focusVertical": "Cover focus · vertical",
    "searchTooLong": "Use at most 200 characters.",
    "videoTooLarge": "Videos can be at most 500 MiB. Your file stays on this device.",
    "attachmentChanged": "The attachment changed while uploading. Your latest file is kept. Try saving again.",
    "reviewChanges": "New changes arrived while saving. Review them and tap Publish again.",
    "useCoverControl": "Add a video here. Use Replace cover to choose its cover image.",
    "cannotConvertMedia": "Remove inline video and live figures before switching to plain text.",
    "otherTab": "This action is in progress in another window. Try again shortly.",
    "receiptExpired": "This saved action is too old to retry safely. Keep the draft and create a new post.",
    "retryLater": "Please wait a moment before trying again.",
    "callBusy": "A call is using audio. Tap Play again after the call.",
    "publicationRetryRequired": "A previous publication needs an explicit retry. Your newer edits are kept.",
    "retryPublication": "Retry previous publication",
    "unreadActivity": "Unread activity",
    "back": "Back"
  }
}
